module.exports = __webpack_public_path__ + "static/media/kite.7b14c380.svg";